module.exports = __webpack_public_path__ + "static/media/L-1.2727354d.svg";